import { useMutation, useQuery } from "react-query";
import { ActionCreators as TypeVoieCreators } from "../../redux/TypeVoie";
import Api, { IApi } from "../../services/Api";
import { Commune, TypeVoie } from "../../services/Api/swagger";
import { getApiEndpoint } from "../../services/Config";

export const useGetCommunes = () => {
  const api: IApi = Api.create(getApiEndpoint());

  return useMutation<Commune[], any, Commune>(
    // @ts-ignore
    (params: Commune) => (api && api.getCommunes(params)) || undefined
  );
};

export const useGetListTypeVoie = () => {
  const api: IApi = Api.create(getApiEndpoint());

  //GET TYPES VOIE
  return useQuery<TypeVoie[]>("typeVoie", () => api && api.getTypesVoie(), {
    retry: false,
    onSuccess: (data) => {
      TypeVoieCreators.loadTypeVoieAsync(data);
    },
  });
};
